import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Link } from "gatsby";

import ListItem from "../list/ListItem";
import RelatedItemTag from "../tag/RelatedItemTag";

function ActionsRelatedListItem({ to, children, tag }) {
  const listItemTag = tag || "blog";
  const listItemClassName = classnames("actions__related__item", "actions__related__item--no-dot");

  return (
    <ListItem className={listItemClassName}>
      <RelatedItemTag name={listItemTag}></RelatedItemTag>
      <Link to={to} className="link">
        {children}
      </Link>
    </ListItem>
  );
}

ActionsRelatedListItem.propTypes = {
  to: PropTypes.string.isRequired,
};

export default ActionsRelatedListItem;
